import '../Components/Blanco'
import '../Components/Graphik'
import 'normalize.css'
import './styles/portal.scss'

// import all used images so that they will be processed by webpack and referenced in markup.
import './images/eoy/bathtub.png'
import './images/eoy/bathtub-2x.png'
import './images/eoy/bathtub-footer.png'
import './images/eoy/bathtub-footer-2x.png'
import './images/eoy/beekeeper.png'
import './images/eoy/beekeeper-2x.png'
import './images/eoy/rainbow.png'
import './images/eoy/rainbow-2x.png'
import './images/eoy/top-publishers/av-club-2x.png'
import './images/eoy/top-publishers/elle-2x.png'
import './images/eoy/top-publishers/inverse-2x.png'
import './images/eoy/top-publishers/ladders-2x.png'
import './images/eoy/top-publishers/prevention-2x.png'
import './images/eoy/top-publishers/scientific-american-2x.png'
import './images/eoy/top-publishers/texas-monthly-2x.png'
import './images/eoy/top-publishers/tonic-2x.png'
import './images/eoy/top-publishers/towards-data-science-2x.png'
